import Vue from "vue";

export const moneyFilter = value => {
  if (!value && value !== 0) return "";

  value = value.toString();

  // TODO: add more parameters to filter to use in format money functions
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

Vue.filter("money", moneyFilter);
